import { getMessages } from '../../../../../store/constants';

export const CARD_SECTION_TAGS = getMessages().getText('card_form_section_tags');
